import { useCarriersQuery } from "@qw/graphql";
import { parseError } from "@qw/qw-common";
import { Column, ColumnContent, Icon, Input, Spinner, useToast } from "@qw/ui";
import { useMemo, useState } from "react";
import { useNavigate } from "react-router";
export const CarriersIndex = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState("");

  const { data: { carriers } = { carriers: [] }, loading } = useCarriersQuery({
    onError: (error) => {
      toast({ title: "Error", description: parseError(error), variant: "destructive" });
    },
  });

  const filtered = useMemo(() => {
    if (!searchQuery.trim()) {
      return carriers;
    }
    const query = searchQuery.toLowerCase();
    return carriers.filter((c) => c.name.toLowerCase().includes(query) || c.slug.toLowerCase().includes(query));
  }, [carriers, searchQuery]);

  if (loading && carriers.length === 0) {
    return (
      <div className="flex-auto flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Column className="flex-auto bg-background flex flex-col">
      <div className="sticky top-0 z-10 p-4">
        <label className="relative w-full max-w-sm">
          <Icon icon="search" className="text-base absolute left-0 top-3.25 pointer-events-none w-9" />
          <span className="sr-only">Search carriers by name or slug</span>
          <Input
            placeholder="Search carriers by name or slug"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-8 py-2 rounded-full bg-muted border-0"
          />
        </label>
      </div>
      <ColumnContent className="p-4 space-y-1 flex-1 overflow-y-auto">
        {filtered.length > 0 ? (
          <div className="rounded border bg-card">
            {filtered.map((carrier) => (
              <button
                key={carrier.id}
                className="flex items-center justify-between w-full px-4 py-3 text-left hover:bg-accent transition-colors border-b last:border-b-0"
                onClick={() => navigate(`/carriers/${carrier.id}`)}
              >
                <div>
                  <div className="font-medium">{carrier.name}</div>
                  <div className="text-sm text-muted-foreground">{carrier.slug}</div>
                </div>
                <Icon icon="chevron_right" className="text-muted-foreground" />
              </button>
            ))}
          </div>
        ) : (
          <div className="text-center text-muted-foreground py-12">No carriers found.</div>
        )}
      </ColumnContent>
    </Column>
  );
};
